import { runOnPage } from './general.js';

runOnPage('about-us-default', () => {
	$(document).ready(function () {
		$(".owl-carousel").each(function () {
			$(this).owlCarousel({
				items: 4,
				nav: true,
				navText: [
					'<span class="icon-chevron-left text-2xl"></span>',
					'<span class="icon-chevron-right text-2xl"></span>'
				],
				loop: true,
				margin: 22,
				autoplay: true,
				autoplayHoverPause: true,
				autoplayTimeout: 2000,
				smartSpeed: 500,
				slideBy: 1,
				dotsEach: true,
				responsive: {
					0: { items: 1, margin: 12 },
					450: { items: 2, margin: 18 },
					768: { items: 3, margin: 22 },
					1024: { items: 4, margin: 22 },
				}
			});
		});

		$('.owl-prev').attr('aria-label', 'Previous slide');
		$('.owl-next').attr('aria-label', 'Next slide');
		$('.owl-dot').each(function (index) {
			$(this).attr('aria-label', 'Slide ' + (index + 1));
		});
	});
});
